module.exports = __webpack_public_path__ + "static/media/lobby.be96ab9f.mp3";